
import Carousel from '~/components/Catalog/Carousel'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import ui from '~/ZenOne-StoryBook/mixins/ui.js'
import { isArrayWithLength } from '~/ZenOne-StoryBook/helpers/types'
import practiceLocation from '~/mixins/practiceLocation'
export default {
  name: 'TopList',
  components: { Carousel },
  mixins: [ui, practiceLocation],
  props: {
    tops: {
      type: Object,
      default: () => {},
      required: true,
    },
    viewportWidth: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    orderedList() {
      return this?.tops?.ordered?.productList ?? []
    },
    recentlyPurchasedList() {
      return this?.tops?.recentlyPurchased?.productList ?? []
    },
    mostPurchasedList() {
      return this?.tops?.mostPurchased?.productList ?? []
    },
    showTopsOrdered() {
      return isArrayWithLength(this?.tops?.ordered?.productList)
    },
    showTopsPurchased() {
      return isArrayWithLength(this?.tops?.mostPurchased?.productList)
    },
  },
  methods: {
    productCardFilterClickHandler(data) {
      this.$emit('productCardFilterClickHandler', data)
    },
    onAddProductToCart(data) {
      this.$emit('onAddProductToCart', data)
    },
    onChangeQtyInCart(data = {}) {
      this.$emit('onChangeQtyInCart', data)
    },
    onShowAddToInventoryDialog(data = {}) {
      this.$emit('on-show-add-to-inventory-dialog', data)
    },
    onAddToRootFolder(data = {}) {
      this.$emit('on-add-to-root-folder', data)
    },
  },
}
